export * from "../global/fire";
